<template>
  <div class="format-radio-buttons">
    <div class="custom-control custom-radio" v-for="(formatType, formatIndex) in formatList" :key="formatIndex">
      <div @click="selectedFormat = formatType.name">
        <input
          class="custom-control-input"
          :id="formatType.name + 'format'"
          :value="formatType.name"
          v-model="selectedFormat"
          @change="$emit('format-changed', formatType.name)"
          name="formatType"
          type="radio"
        />
        <label class="custom-control-label" :for="formatType.name + 'format'">
          {{ formatType.prettyName || $t("radio-btn-group.no-formatting") }}
        </label>
        <div v-if="formatType.name === selectedFormat">
          <div v-for="(input, inputIndex) in formatType.inputs" :key="input.name" class="format-input">
            <label class="format-label">{{ input.label }}</label>
            <select
              v-if="input.type === 'format'"
              v-model="formatType.inputValues[inputIndex]"
              :placeholder="input.placeholder"
              @change="$emit('on-format-input', formatType.name)"
              class="form-control form-control-sm"
            >
              <option :value="undefined">{{ $t("radio-btn-group.no-formatting") }}</option>
              <option
                v-for="formatType in noInputVariableFormats(input.formatType.toLowerCase())"
                :key="formatType.name"
                :value="formatType.name"
                v-html="formatType.prettyName"
              />
            </select>
            <input
              v-else-if="input.type === 'number'"
              type="number"
              v-model="formatType.inputValues[inputIndex]"
              @click.stop
              @input="$emit('on-format-input', formatType.name)"
              class="form-control form-control-sm"
              :placeholder="input.placeholder"
            />
            <input
              v-else
              v-model="formatType.inputValues[inputIndex]"
              @click.stop
              @input="$emit('on-format-input', formatType.name)"
              class="form-control form-control-sm"
              :placeholder="input.placeholder"
            />
          </div>
        </div>
        <p class="radio-button-label-caption" v-if="!formatsForMethods">
          {{ $t("radio-btn-group.result") }}
          <span v-if="examples[formatIndex] !== undefined" v-html="examples[formatIndex].result"></span>
          <span v-else>{{ $t("radio-btn-group.loading") }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedFormat: this._selectedFormat,
    };
  },
  methods: {
    noInputVariableFormats(formatType){
      return this.$store.state.variableFormats[formatType].filter(f => f.inputs == (null || undefined))
    }
  },
  watch:{
      selectedFormat: {
      handler() {
        this.$emit('format-changed', this.selectedFormat)
      },
    },
  },
  props: {
    formatList: Array,
    _selectedFormat: String,
    examples: Array,
    formatsForMethods: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less">
.format-radio-buttons {
  .custom-control.custom-radio:not(:last-child) {
    margin-bottom: 10px;
  }

  .custom-control-label {
    color: var(--charcoal);
  }

  .radio-button-label-caption {
    font-size: 12px;
    color: var(--charcoal-50);
    margin-bottom: 0;
    margin-top: 4px;

    span {
      max-width: 226px;
      word-break: break-word;
    }
  }

  .var-header {
    user-select: none;
    padding: 6px 20px;
    padding-bottom: 6px;
    text-transform: uppercase;
  }

  .format-input {
    label {
      margin: 8px 0 4px 0;
    }
    .format-label {
      color: var(--charcoal-75);
      font-size: 12px;
      font-weight: 500;
    }

    input,
    select {
      width: 100%;
      &:focus,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: var(--orange-web);
    background-color: var(--orange-web);
  }
}
</style>
